export function orderHasAdminOverrideBug(order) {
  const products = order?.metadata?.products;
  if (!Array.isArray(products)) return false;

  return products.some(
    (product) => !product?.isCancelled && product?.overriddenByAdmin === true
  );
}

export function countAdminOverrideProducts(order) {
  const products = order?.metadata?.products;
  if (!Array.isArray(products)) return 0;

  return products.filter(
    (product) => !product?.isCancelled && product?.overriddenByAdmin === true
  ).length;
}
